


export const createPingSystem = ({sendMessageSystem})=>{

    return {
        handleRequestPing:()=> {
        sendMessageSystem.send('mi.ping',{
            sender:"master-interface",
            timestamp:Date.now()
        })}
    }
}



// WEBPACK FOOTER //
// ./djangosite/master/frontend/src/search-panel/pingSystem.js